import React, { createContext, useContext, useState, useEffect } from 'react';
import { lightThemeInstance, darkThemeInstance } from '../Theme/Theme';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    // Check localStorage for saved preference
    const saved = localStorage.getItem('darkMode');
    if (saved !== null) {
      return JSON.parse(saved);
    }
    // Default to dark mode when no preference is saved
    return true;
  });

  const [currentTheme, setCurrentTheme] = useState(
    isDarkMode ? darkThemeInstance : lightThemeInstance
  );

  const toggleTheme = () => {
    setIsDarkMode(prev => !prev);
  };

  const setTheme = (darkMode) => {
    setIsDarkMode(darkMode);
  };

  useEffect(() => {
    // Update theme when isDarkMode changes
    setCurrentTheme(isDarkMode ? darkThemeInstance : lightThemeInstance);
    
    // Save preference to localStorage
    localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
    
    // Update document body class for global CSS
    document.body.classList.toggle('dark-mode', isDarkMode);
  }, [isDarkMode]);

  // Note: Removed system theme change listener since we now default to dark mode
  // Users can manually toggle theme using the theme toggle button

  const value = {
    isDarkMode,
    currentTheme,
    toggleTheme,
    setTheme,
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}; 